<template>
  <div id="widget-license-flash-message">
    <template v-if="license_message">
      <div class="flash-message message-warning">
        <i class="icon-error fa fa-warning"></i>
        License Message
        <div class="flash-message-close">x</div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'widget-license-flash-message'
}
</script>


// WEBPACK FOOTER //
// WidgetLicenseFlashMessage.vue?7443e744